import "./Services.css";

const Services = () => {
    return (
        <section className="services" id="services">
            <div className="services-container">

                {/* Header */}
                <div className="services-header">
                    <span className="services-tag">Our Services</span>
                    <h2>Everything Your Home Needs</h2>
                    <p>
                        From planning and visualization to execution — we deliver
                        complete, thoughtful interior solutions.
                    </p>
                </div>

                {/* Services Grid */}
                <div className="services-grid">

                    <div className="service-card">
                        <img
                            src="https://preview.redd.it/sketchup-to-v-ray-3d-interior-rendering-before-after-v0-le6uglc33mlf1.png?width=1080&crop=smart&auto=webp&s=4964da3f353c9f830b9fb3274c1ebcbaab7a30ea"
                            alt="3D Interior Renders"
                        />
                        <h3>3D Renders Based on Your Flat</h3>
                        <p>
                            Photo-realistic 3D designs created from your actual floor plan,
                            helping you visualize your home before execution.
                        </p>
                    </div>

                    <div className="service-card">
                        <img
                            src="https://nppartners.net/wp-content/uploads/2021/10/be762f3cf400aa32891a4d160864187d.jpg"
                            alt="Space Planning and Layout"
                        />
                        <h3>Space Planning & Layout Design</h3>
                        <p>
                            Intelligent layouts that maximize space, improve flow, and
                            enhance everyday living.
                        </p>
                    </div>

                    <div className="service-card">
                        <img
                            src="https://images.kreatecube.com/usefull/Common/2/386.jpg"
                            alt="Theme and Style Selection"
                        />
                        <h3>Theme & Style Selection</h3>
                        <p>
                            Carefully curated themes, colors, and materials tailored to
                            your lifestyle and preferences.
                        </p>
                    </div>

                    <div className="service-card">
                        <img
                            src="https://haydenhill.co/cdn/shop/files/a_luxury_men_s_dressing_room.jpg?v=1674933466&width=960"
                            alt="Wardrobe and TV Unit Design"
                        />
                        <h3>Next-Generation Wardrobe & TV Units</h3>
                        <p>
                            Modern wardrobe systems and TV units with premium finishes
                            and functional detailing.
                        </p>
                    </div>

                    <div className="service-card">
                        <img
                            src="https://www.everestind.com/blog/wp-content/uploads/2025/09/Types_of_False_Ceilings_to_Transform_Your_Home_Interiors.jpg"
                            alt="False Ceiling Design" />
                        <h3>False Ceiling Design</h3>
                        <p>
                            Elegant false ceiling designs that add depth, character, and
                            a touch of luxury to your living spaces.
                        </p>
                    </div>

                    <div className="service-card">
                        <img
                            src="https://wallpaperfixing.com/wp-content/uploads/2025/02/Textured-Wall-Paint.jpg"
                            alt="Wall Painting" />
                        <h3>Wall Painting</h3>  
                        <p>
                            Expert wall painting services that bring color, texture, and
                            personality to your interiors.
                        </p>
                    </div>

                </div>

            </div>
        </section>
    );
}

export { Services };